import { render, staticRenderFns } from "./FlowsListItem.vue?vue&type=template&id=3bc29557&scoped=true&"
import script from "./FlowsListItem.vue?vue&type=script&lang=js&"
export * from "./FlowsListItem.vue?vue&type=script&lang=js&"
import style0 from "./FlowsListItem.vue?vue&type=style&index=0&id=3bc29557&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc29557",
  null
  
)

export default component.exports